var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "padding-top-3xl padding-bottom-5xl",
      staticStyle: { "background-color": "var(--white)" },
      attrs: { id: "open-source" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row align-center" }, [
          _c(
            "div",
            { staticClass: "column-12 tablet:column-6 laptop:column-4" },
            [
              _c(
                "div",
                {
                  staticClass: "card header gray",
                  staticStyle: {
                    "--card-header-background": "var(--fa-lt-gravy)",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v7.solid.faHandHoldingHeart,
                          size: "2x",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(1),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column-12 tablet:column-6 laptop:column-4" },
            [
              _c(
                "div",
                {
                  staticClass: "card header gray",
                  staticStyle: {
                    "--card-header-background": "var(--fa-lt-gravy)",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v7.solid.faRocketLaunch,
                          size: "2x",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(2),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column-12 tablet:column-6 laptop:column-4" },
            [
              _c(
                "div",
                {
                  staticClass: "card header gray",
                  staticStyle: {
                    "--card-header-background": "var(--fa-lt-gravy)",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v7.solid.faShieldHalved,
                          size: "2x",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(3),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row align-middle margin-top-lg text-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "column-12 laptop:column-7 laptop:offset-1 margin-bottom-xs laptop:margin-bottom-0",
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "strong display-flex align-middle align-center laptop:align-right",
                    staticStyle: {
                      "--link-color": "var(--fa-navy)",
                      "--link-hover-color": "var(--fa-dk-blue)",
                    },
                    attrs: {
                      href: "https://github.com/FortAwesome/Font-Awesome",
                      target: "_blank",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture(
                          "home:github_project_link_click",
                          { location: "open_source" }
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "padding-right-md padding-y-sm" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.$v7.brands.faGithub, size: "2xl" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h5", { staticClass: "margin-0 text-left" }, [
                      _vm._v(
                        "Font Awesome is one of the top open source projects on GitHub."
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "column-12 laptop:column-3 margin-top-4xs laptop:text-left",
              },
              [
                _c(
                  "github-button",
                  {
                    attrs: {
                      href: "https://github.com/FortAwesome/Font-Awesome",
                      "data-show-count": "true",
                      "aria-label": "Star FortAwesome/Font-Awesome on GitHub",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture(
                          "home:github_star_button_click",
                          { location: "open_source" }
                        )
                      },
                    },
                  },
                  [_vm._v("\n          Star\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "github-button",
                  {
                    attrs: {
                      href: "https://github.com/FortAwesome/Font-Awesome/fork",
                      "data-show-count": "true",
                      "aria-label": "Fork FortAwesome/Font-Awesome on GitHub",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture(
                          "home:github_fork_button_click",
                          { location: "open_source" }
                        )
                      },
                    },
                  },
                  [_vm._v("\n          Fork\n        ")]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row margin-bottom-4xl" }, [
      _c("div", { staticClass: "column-12 text-center" }, [
        _c("h1", { staticClass: "h2 margin-y-md" }, [
          _vm._v("Proudly Open Source"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "line-length-xl margin-auto" }, [
          _vm._v(
            "\n          In 2012, we created the first version of our open source icon, and it continues to be one of the top open source projects on Github. With the help\n          of our subscription plans, it's only gotten better.\n        "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-left" }, [
      _c("h3", { staticClass: "h5" }, [_vm._v("Always Free")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "With every version, Font Awesome has always had free and open source icons. We'll always stay that way."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-left" }, [
      _c("h3", { staticClass: "h5" }, [_vm._v("Support Open Source")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Thanks to Pro Subscribers, Font Awesome Free has increased by over 250% since version 4."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-left" }, [
      _c("h3", { staticClass: "h5" }, [_vm._v("No Shenanigans")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Need more icons or services? If you want them, you subscribe. We'll never sell your data."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }